import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";
import { getGeneralSettings } from '../../../Common/Appcommon';

class LegacyCustomMenus extends React.Component {
   constructor(props) {
    super(props);
    let pageTitle = "";
    let iurl = "";
    if (props.match?.params?.menu) {
        pageTitle = props.match.params.menu;
    }
    if (props.match?.params?.iurl) {
        iurl = decodeURIComponent(props.match.params.iurl);
    }
    this.state = {
        pageTitle,
        iurl
    };
}
 async componentDidMount() {
    const settingString = await getGeneralSettings("CUSTOM_MENUS_INFO", true);
    let setting = null;
    try {
      setting = JSON.parse(settingString); // Parse JSON string
    } catch (e) {
      console.error("Invalid JSON:", e);
    }

    let pageTitle =  this.state.pageTitle;
    if (setting?.menus && this.state.iurl) {
      const match = setting.menus.find(menuItem => menuItem[2] === this.state.iurl);

      if (match) {
        pageTitle = match[1]; 
      }
    }
    document.title = "Cratio - "+pageTitle;
  }
    render() {
         let {pageTitle,iurl} = this.state;
        return (
            <LegacyFrame withHeader={true} isPageTitleNeeded={true} pageTitle={pageTitle} iurl={iurl} customClass={"field-customization-container"} />
        );
    }
}

export default LegacyCustomMenus;